import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { IS_LOAD, IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { PaginatorLiteralsFacadeService } from 'src/app/shared/services/literals/paginator.literals.facade.service';
import { SchemasLiteralsFacadeService } from 'src/app/shared/services/literals/schemas.literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import {
  Companies,
  Countries,
  LevelsRedemptionTypes,
  Nexus,
  SchemaSearchPayload,
  SchemaSearchResponse,
} from '../models/schemas.model';
import { SchemasSearchFacadeService } from './search.facade.service';

@Injectable({ providedIn: 'root' })
export class SearchSchemasService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private searchFacade: SchemasSearchFacadeService,
    private paginatorFacade: PaginatorFacadeService,
    private schemasLiterals: SchemasLiteralsFacadeService,
    private paginatorLiteralsFacade: PaginatorLiteralsFacadeService,
  ) {}

  companies(): Observable<Companies[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/companies';

    return this.http.get<Companies[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  roundingModes(): Observable<string[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/system/rounding-modes';

    return this.http.get<string[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  nexus(): Observable<Nexus[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/system/nexus';

    return this.http.get<Nexus[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  levels(): Observable<LevelsRedemptionTypes[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/schemas-properties/levels';

    return this.http.get<LevelsRedemptionTypes[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  redemptionTypes(): Observable<LevelsRedemptionTypes[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/schemas-properties/redemptionTypes';

    return this.http.get<LevelsRedemptionTypes[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  taxOffices(): Observable<any> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/system/tax-offices';

    return this.http.get<any>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  countries(): Observable<Countries[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/countries';

    return this.http.get<Countries[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  searchSchemas(): Observable<SchemaSearchResponse> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/schemas/findByFilter';

    const body: SchemaSearchPayload = {
      loyaltySchemaCode: this.searchFacade.schemaCode ? this.searchFacade.schemaCode : null,
      loyaltySchemaCompanyName: this.searchFacade.companyTitle ? this.searchFacade.companyTitle : null,
      maxResult: this.paginatorFacade.itemsNumber,
      sortField:
        this.paginatorFacade.selectedSortField === this.schemasLiterals.sortSchemaName
          ? 'SCHEMA_NAME'
          : this.paginatorFacade.selectedSortField === this.schemasLiterals.sortSchemaCode
            ? 'SCHEMA_CODE'
            : 'CREATION_DATE',
      sortOrder: this.paginatorFacade.selectedOrder === this.paginatorLiteralsFacade.orderAsc ? 'ASC' : 'DESC',
      start: this.paginatorFacade.pageIndex * 10,
      vatNumber: this.searchFacade.vatNumber ? this.searchFacade.vatNumber : null,
    };

    return this.http.post<SchemaSearchResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  countSchemas(): Observable<number> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/schemas/countByFilter';

    const body: SchemaSearchPayload = {
      loyaltySchemaCode: this.searchFacade.schemaCode ? this.searchFacade.schemaCode : null,
      loyaltySchemaCompanyName: this.searchFacade.companyTitle ? this.searchFacade.companyTitle : null,
      maxResult: this.paginatorFacade.itemsNumber,
      sortField:
        this.paginatorFacade.selectedSortField === this.schemasLiterals.sortSchemaName
          ? 'SCHEMA_NAME'
          : this.paginatorFacade.selectedSortField === this.schemasLiterals.sortSchemaCode
            ? 'SCHEMA_CODE'
            : 'CREATION_DATE',
      sortOrder: this.paginatorFacade.selectedOrder === this.paginatorLiteralsFacade.orderAsc ? 'ASC' : 'DESC',
      start: this.paginatorFacade.pageIndex * 10,
      vatNumber: this.searchFacade.vatNumber ? this.searchFacade.vatNumber : null,
    };

    return this.http.post<number>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }
}
